import React from 'react';
import { Hero } from './components/Hero';
import { SalesLetter } from './components/SalesLetter';
import { TomosSection } from './components/TomosSection';
import { SocialProof } from './components/SocialProof';
import { HeroProof } from './components/HeroProof';
import { BenefitsSection } from './components/BenefitsSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { CostSection } from './components/CostSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ink-950 font-sans" data-id="element-0" data-mp="23vunsb2v8su3">
      <Hero data-id="element-1" data-mp="23v2sl1d6kx4c" />
      <main data-id="element-2" data-mp="23ti8y6semyl9">
        <SalesLetter data-id="element-3" data-mp="3ijxo6nd1puib" />
        <TomosSection data-id="element-4" data-mp="3ikh5q2ysagvt" />
        <BonosSection data-id="element-5" data-mp="3ij66mgga9xb1" />
        <HeroProof data-id="element-6" data-mp="3ijpef4c7z5bc" />
        <SocialProof data-id="element-7" data-mp="3mlj9mx3nbh44" />
        <BenefitsSection data-id="element-8" data-mp="3ml12v6jcxkhy" />
        <PricingSection data-id="element-9" data-mp="3mk868ye44bdj" />
        <CostSection data-id="element-10" data-mp="3mjg9vlcoy9m7" />
        <TestimonialsSection data-id="element-11" data-mp="3rc9d24sih9w6" />
        <FaqSection data-id="element-12" data-mp="3rbznujfaj6rj" />
        <GuaranteeSection data-id="element-13" data-mp="3rdkkqfp2v1sk" />
        <FinalCta data-id="element-14" data-mp="3recbnd7qcbci" />
      </main>
      <Footer data-id="element-15" data-mp="6hqffdy0fe4" />
    </div>;
}